<template lang="pug">
  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-lg-12
        .ibox.float-e-margins
          .ibox-title
            template(v-if="$route.params.type === 'sale'")
              template(v-if="$route.query.byAdmin")
                h5 NOT AVAILABLE - รายละเอียดการขายโดยตัวแทนอื่น / เจ้าของ
              template(v-else)
                h5 SOLD - ข้อมูลสัญญาการขาย
            template(v-else)
              template(v-if="$route.query.byAdmin")
                h5 NOT AVAILABLE - รายละเอียดการขายโดยตัวแทนอื่น / เจ้าของ
              template(v-else)
                h5 RENTED - ข้อมูลสัญญาการเช่า

          .ibox-content
            form.form-horizontal(v-on:submit.prevent="onSubmit")
              .form-group
                label.col-sm-2.control-label PROJECT
                .col-sm-10.col-md-4
                  p.form-control-static {{ contract.project_name }}
              
              .form-group(v-if="!makeByAdmin")
                label.col-sm-2.control-label SALE <span class="text-danger">*</span>
                .col-sm-10.col-md-4
                  p(v-if="$ls.get('user').role_id !== '1'").form-control-static {{ $ls.get('user').name }}
                  select.form-control(v-else v-model="contract.seller_id" requred)
                    option(v-for="seller in sellers" :value="seller.id") {{ seller.name ? seller.name : 'No name ?' }}
              
              .form-group(v-if="!makeByAdmin")
                label.col-sm-2.control-label DEPOSIT
                .col-sm-10.col-md-4
                  input.form-control(type="text" placeholder="" v-model="contract.deposit" @blur="contract.deposit = formatNumber(contract.deposit)")
              
              .form-group(v-if="!makeByAdmin")
                label.col-sm-2.control-label DEPOSIT DATE
                .col-sm-10.col-md-4
                  datepicker(input-class="form-control" placeholder="DEPOSITE DATE" v-model="contract.deposit_date")

              .form-group
                label.col-sm-2.control-label PRICE <span class="text-danger">*</span>
                .col-sm-10.col-md-4
                  input.form-control(type="text" placeholder="" v-model="contract.price" @blur="contract.price = formatNumber(contract.price)" requred)
              
              .form-group(v-if="!makeByAdmin")
                label.col-sm-2.control-label COMMISSION
                .col-sm-10.col-md-4
                  input.form-control(type="text" placeholder="" v-model="contract.commission" @blur="contract.commission = formatNumber(contract.commission)")

              .form-group(:class="error.contract_periot ? 'has-error' : ''")
                template(v-if="$route.params.type === 'sale'")
                  label.col-xs-12.col-sm-2.control-label CONTRACT DATE <span class="text-danger">*</span>
                  .datepicker.col-sm-10.col-md-4
                    datepicker(input-class="form-control" placeholder="DATE" v-model="contract.contact_start" requred)  
                template(v-else)
                  label.col-xs-12.col-sm-2.control-label CONTRACT PERIOT
                  .datepicker.col-sm-5.col-md-2
                    datepicker(input-class="form-control" placeholder="START" v-model="contract.contact_start")
                  .datepicker.col-sm-5.col-md-2
                    datepicker(input-class="form-control" placeholder="END" v-model="contract.contact_end")
                  p.help-block {{ error.contract_periot }}
              
              .form-group
                label.col-xs-12.col-sm-2.control-label CONTRACT PICTURES
                .col-sm-10
                  upload(class="btn btn-outline btn-white" :url="`${baseUrl}s3/upload/processs3.php`" :crop="false" :multiple="true" @imageuploaded="addPic" @imageuploading="upload") <i v-show="uploading" class="fa fa-spinner fa-pulse fa-fw"></i> {{ uploading ? 'Uploading...' : 'Upload Image'}}
                  ul.photos
                      li(v-for="(pic, index) in contract.pictures")
                        img(v-lazy="pic.path" @click="showLightbox(contract.pictures, index)")
                        .del(@click="deletePic(index)"): i.text-warning.fa.fa-times.fa-2x

              .row
                .col-xs-12
                  hr
                  button.btn.btn-primary(type="submit" :disabled="uploading") Save change
                  | &nbsp;&nbsp;
                  button.btn.btn-white(type="button" @click="$router.go(-1)") Cancel

          .ibox-footer(v-show="contract.update_by")
            .row
              .col-xs-12 <b>Update by</b> {{ contract.update_by }} ({{ formatDate(contract.update_date) }})

    lightbox(ref="lightbox" :images="lightboxImages" :show-caption="false" :show-light-box="false" :start-at="startAt")

</template>

<script>
  import axios from 'axios'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'
  import numeral from 'numeral'
  import Datepicker from 'vuejs-datepicker'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import Lightbox from 'vue-image-lightbox'
  import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
  import moment from 'moment'

  export default {
    components: {
      Datepicker,
      'upload': VueCoreImageUpload,
      Lightbox
    },
    data () {
      return {
        makeByAdmin: this.$route.query.byAdmin ? this.$route.query.byAdmin : false,
        baseUrl: global.baseUrl,
        uploading: false,
        id: this.$route.params.id,
        contract: {},
        sellers: [],
        lightboxImages: [],
        startAt: 0,
        error: {
          contract_periot: ''
        }
      }
    },
    created () {
      // console.log(this.makeByAdmin)
      if (this.$ls.get('user').role_id === '1') {
        this.fetchSellmans()
      }
    },
    mounted () {
      this.fetchContract()
    },
    methods: {
      formatNumber (number) {
        return numeral(number).format('0,0 $')
      },
      deformatNumber (number) {
        return numeral(number).value()
      },
      formatDate (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      fetchContract () {
        axios.get(`sale/project_id/${this.id}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.contract = res.data.data
              console.log(this.contract)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      fetchSellmans () {
        axios.get(`user/list`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.sellers = res.data.data
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      upload () {
        this.uploading = true
      },
      addPic (res) {
        // Add
        for (var pic of res.images) {
          this.contract.pictures.push({
            id: null,
            path: pic.src,
            title: pic.title
          })
        }
        this.uploading = false
      },
      deletePic (index) {
        var _this = this
        swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete!',
          cancelButtonText: 'No'
        }).then(function () {
          _this.contract.pictures.splice(index, 1)
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            swal(
              'Cancelled'
            )
          }
        })
      },
      onSubmit () {
        this.contract.update_by_id = this.$ls.get('user').id
        if (this.makeByAdmin) {
          this.contract.seller_id = null
          if (this.contract.agent_name === null) this.contract.agent_name = this.$ls.get('user').name
        } else {
          this.contract.agent_name = null
          if (this.contract.seller_id === null) this.contract.seller_id = this.$ls.get('user').id
        }

        if (this.$route.params.type === 'sale' && this.contract.contact_start) {
          this.contract.contact_end = null
          this.callSaleApi()
        } else if (this.contract.contact_start && this.contract.contact_end) {
          this.callSaleApi()
        } else {
          this.error.contract_periot = 'ต้องการข้อมูลช่วงเวลาของสัญญา'
        }
      },
      callSaleApi () {
        if (this.contract.sale_id) {
          // Edit
          axios.put(`sale`, this.contract).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Success.', res.data.message, { timeOut: 2000 })
                this.$router.go(-1)
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        } else {
          // Create
          axios.post(`sale`, this.contract).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Success.', res.data.message, { timeOut: 2000 })
                this.$router.go(-1)
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        }
      },
      showLightbox (images, index) {
        console.log(images)
        this.startAt = index
        this.lightboxImages = []
        for (var image of images) {
          console.log(image)
          image.src = `${image.path}`
          image.thumb = `${image.path}`
          this.lightboxImages.push(image)
        }
        this.$refs.lightbox.showImage(0)
        console.log(this.lightboxImages)
      }
    }
  }
</script>

<style lang="less" scoped>
  .photos {
    list-style: none;
    margin: 10px 0;
    padding: 0;

    > li {
      float: left;
      position: relative;
      width: 120px;
      height: 120px;
      background-color: #EEE;
      margin: 0px 10px 10px 0;
      overflow: hidden;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      .del {
        position: absolute;
        top: 2px;
        right: 5px;
      }
    }
  }

  .datepicker {
    margin-bottom: 15px;
  }
</style>




// WEBPACK FOOTER //
// contract.vue?83f6bf82